import * as React from "react";
import Image from "next/image";

import { Grid, Typography, makeStyles } from "@material-ui/core";
import uuid from "react-uuid";
import Empty from "../../../static/Empty";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#fff",
    margin: "10px auto",
    padding: "20px 10px",
    border: "solid 1px #B6B3B3",
  },
  p: {
    padding: 10,
  },
  t1: {
    color: "#0A369D",
    fontWeight: "bold",
    fontSize: 16,
    marginBottom: 10,
  },
  t2: {
    color: "#292929",
    fontSize: 16,
    fontFamily: "Vazir",
  },
  image: {
    borderRadius: "100%",
    border: "solid 1px #aaa !important",
  },
  card: {
    backgroundColor: "#FAFAFA",
    border: "solid 1px #B6B3B3",
    padding: "20px 10px",
    borderRadius: "5px",
  },
}));

const Members = ({ data = [] }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      {data.length > 0 ? (
        <>
          <Grid item xs={12} className={classes.p}>
            <Typography variant="h2" className={classes.t1}>
              اعضای سازمان
            </Typography>
          </Grid>
          {data.map((item) => (
            <Grid item xs={12} key={uuid()} className={classes.p}>
              <Grid container className={classes.card}>
                <Grid item xs={1}>
                  {item.avatar && (
                    <Image
                      src={item.avatar}
                      blurDataURL={item.avatar}
                      placeholder="blur"
                      width={50}
                      height={50}
                      className={classes.image}
                      alt={item.name}
                    />
                  )}
                </Grid>
                <Grid item xs={11} container>
                  {item.name && (
                    <Grid item xs={6}>
                      <Typography variant="h4" className={classes.t1}>
                        نام و نام خانوادگی:{" "}
                        <span className={classes.t2}>{item.name}</span>
                      </Typography>
                    </Grid>
                  )}
                  {item.excerpt && (
                    <Grid item xs={6}>
                      <Typography variant="h4" className={classes.t1}>
                        توضیح مختصر:{" "}
                        <span className={classes.t2}>{item.excerpt}</span>
                      </Typography>
                    </Grid>
                  )}
                  {item.unit && (
                    <Grid item xs={6}>
                      <Typography variant="h4" className={classes.t1}>
                        سمت : <span className={classes.t2}>{item.unit}</span>
                      </Typography>
                    </Grid>
                  )}
                  {item.education_level && (
                    <Grid item xs={6}>
                      <Typography variant="h4" className={classes.t1}>
                        تحصیلات :{" "}
                        <span className={classes.t2}>
                          {item.education_level}
                        </span>
                      </Typography>
                    </Grid>
                  )}
                  {item.birth_date && (
                    <Grid item xs={6}>
                      <Typography variant="h4" className={classes.t1}>
                        تاریخ تولد :{" "}
                        <span className={classes.t2}>{item.birth_date}</span>
                      </Typography>
                    </Grid>
                  )}
                  {item.instagram && (
                    <Grid item xs={6}>
                      <Typography variant="h4" className={classes.t1}>
                        اینستاگرام :{" "}
                        <span className={classes.t2}>{item.instagram}</span>
                      </Typography>
                    </Grid>
                  )}
                  {item.linkedin && (
                    <Grid item xs={6}>
                      <Typography variant="h4" className={classes.t1}>
                        لینکدین :{" "}
                        <span className={classes.t2}>{item.linkedin}</span>
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          ))}
        </>
      ) : (
        <Empty />
      )}
    </Grid>
  );
};

export default Members;
